import { AppBar } from '@mui/material'
import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import Toolbar from '@mui/material/Toolbar'
import useMediaQuery from '@mui/material/useMediaQuery'

import { Link, routes } from '@redwoodjs/router'

import MajrLogo from 'src/components/MajrLogo'

import DrawerContent from './DrawerContent'
import DrawerMenu from './DrawerMenu'

const Header = () => {
  const theme = useTheme()
  const isMDUp = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <>
      <AppBar
        component="header"
        position="relative"
        elevation={3}
        sx={{
          zIndex: 1,
          backgroundColor: 'white',
        }}
      >
        <Toolbar sx={{ justifyContent: 'center' }}>
          {!isMDUp ? <DrawerMenu /> : null}

          <Link to={routes.home()}>
            <MajrLogo
              sx={{
                height: '30px',
                width: '96px',
              }}
            />
          </Link>
        </Toolbar>
      </AppBar>
      {isMDUp ? (
        <Box
          position="fixed"
          sx={{
            borderRight: '1px solid #D1D6D7',
            top: '64px',
            bottom: 0,
            overflowY: 'auto',
          }}
        >
          <DrawerContent />
        </Box>
      ) : null}
    </>
  )
}

export default Header
